import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { NectarMissionDetailForAuthorizedUser } from '@/features/missions/MissionsWrappers'
import { Page } from '@/ui-kit'
import { useParams } from 'react-router-dom'

const NectarTaskWebviewPage = () => {
  const { projectId } = useParams<{ projectId: string }>()

  return (
    <MissionsUrlProvider isWebview={true}>
      <Page>
        <NectarMissionDetailForAuthorizedUser missionId={projectId ?? ''} />
      </Page>
    </MissionsUrlProvider>
  )
}

export default NectarTaskWebviewPage
